import { Rule, Storage } from "@dashboard-v3/api";
import { FolderType } from "../Steps/StorageFilepath/FilepathSelector/types";
import { syncAllByRuleDefaultValue } from "./initStorage";
import i18n from "i18n";

export default function initStorageLocation(
  actionType: "DRAG_AND_DROP"
): Storage["location"];

export default function initStorageLocation(
  actionType: Rule["actionType"],
  targetType: Rule["targetType"],
  storage?: Storage | null
): Storage["location"];

export default function initStorageLocation(
  actionType: Rule["actionType"],
  targetType?: Rule["targetType"],
  storage?: Storage
): Storage["location"] {
  if (actionType === "DRAG_AND_DROP") {
    return {
      folderStructure: "",
      parentId: FolderType.SOURCE_FOLDER,
    };
  }

  if (!targetType) {
    return { folderStructure: null };
  }

  const actionName = getActionName(actionType);

  let location: Storage["location"] = {
    folderStructure: null,
  };

  switch (targetType) {
    case "MAIL_BOX":
      location = {
        folderStructure: `${actionName}/{inbox_folder_name}/{from_address}/${storageLocationSuffix}`,
      };
      break;

    case "EMAIL_FLOW":
      const syncAllByRule = storage?.syncAllByRule ?? syncAllByRuleDefaultValue;
      const storageProvider = storage?.provider || null;

      location = emailFlowStorageLocation(
        actionName,
        syncAllByRule,
        storageProvider
      );
      break;

    case "ARCHIVING_ADDRESS":
      location = {
        folderStructure: `${actionName}/{from_address}/${storageLocationSuffix}`,
      };
      break;

    default:
      break;
  }

  if (storage?.provider === "EGNYTE" || storage?.provider === "EGNYTE_GOV") {
    location.parentId = "shared";
  }

  return location;
}

const storageLocationSuffix =
  "{subject_normalized}/{sent_or_received_date_yyyyMMdd}";

export function emailFlowStorageLocation(
  actionName: string,
  syncAllByRule: boolean,
  storageProvider?: Storage["provider"]
): Storage["location"] {
  let suffix = storageLocationSuffix;

  if (storageProvider === "MXHERO_STORAGE") {
    suffix = "{subject_normalized}/{sent_date_yyyyMMdd_HHmm}";
  }

  if (syncAllByRule) {
    return { folderStructure: `${actionName}/{sender_address}/${suffix}` };
  }

  return {
    folderStructure: `${actionName}/{email_address}/{email_peer_address}/${storageLocationSuffix}`,
  };
}

export function getActionName(actionType: Rule["actionType"]): string {
  const t = i18n.t.bind(i18n);
  return t(`actions.${actionType}.title`, { ns: "rules" });
}
